const formatDateParam = date => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getPresetDateRange = preset => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const toDate = formatDateParam(today);
  const from = new Date(today);

  if (preset === '1d') {
    from.setDate(from.getDate() - 1);
    return { fromDate: formatDateParam(from), toDate };
  }

  if (preset === '3d') {
    from.setDate(from.getDate() - 2);
    return { fromDate: formatDateParam(from), toDate };
  }

  if (preset === '7d') {
    from.setDate(from.getDate() - 6);
    return { fromDate: formatDateParam(from), toDate };
  }

  return { fromDate: '', toDate: '' };
};

const formatFilterDate = dateString => {
  if (!dateString) return '-';
  const [year, month, day] = dateString.split('-');
  if (!year || !month || !day) return dateString;
  return `${day}/${month}/${year}`;
};

const formatCurrency = value => {
  const amount = Number(value);
  if (Number.isNaN(amount)) return '₹0';
  return `₹${amount.toLocaleString('en-IN')}`;
};

export { formatDateParam, formatFilterDate, formatCurrency, getPresetDateRange };
